"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/no-unstable-nested-components */
var react_1 = __importDefault(require("react"));
var react_select_1 = __importStar(require("react-select"));
function SingleSelect(_a) {
    var options = _a.options, placeholder = _a.placeholder, getOptionLabel = _a.getOptionLabel, getOptionValue = _a.getOptionValue, isOptionDisabled = _a.isOptionDisabled, value = _a.value, onChange = _a.onChange, isDisabled = _a.isDisabled, isClearable = _a.isClearable, isLoading = _a.isLoading, className = _a.className, hasError = _a.hasError, isMenuPositionStatic = _a.isMenuPositionStatic, defaultMenuIsOpen = _a.defaultMenuIsOpen, hideSelectedOptions = _a.hideSelectedOptions, customCssProperties = _a.customCssProperties, isSearchable = _a.isSearchable, suffix = _a.suffix, name = _a.name, withSearchInputIcon = _a.withSearchInputIcon, autoFocus = _a.autoFocus, withTooltipAndTruncatedText = _a.withTooltipAndTruncatedText;
    var _b = customCssProperties || {}, customBorderHoverColor = _b.customBorderHoverColor, customBorderFocusColor = _b.customBorderFocusColor, customBackgroundColor = _b.customBackgroundColor, customFontColor = _b.customFontColor, customBackgroundColorOnHover = _b.customBackgroundColorOnHover, customBorderStyle = _b.customBorderStyle, customBoxShadow = _b.customBoxShadow;
    var getBorderColor = function (menuIsOpen) { return (menuIsOpen ? '#5a0077' : '#d8dee2'); };
    function SingleValueComponent(_a) {
        var children = _a.children, props = __rest(_a, ["children"]);
        return (react_1.default.createElement(react_select_1.components.SingleValue, __assign({}, props),
            children,
            " ",
            suffix));
    }
    function OptionComponent(props) {
        return (react_1.default.createElement("a", { title: props === null || props === void 0 ? void 0 : props.label, style: { color: 'black', cursor: 'pointer' } },
            react_1.default.createElement(react_select_1.components.Option, __assign({}, props, { className: "truncated" }))));
    }
    function InputComponent(props) {
        var isHidden = props.isHidden;
        if (isHidden) {
            return react_1.default.createElement(react_select_1.components.Input, __assign({}, props));
        }
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("span", { className: "dropdown-menu-input-container-icon implioicons-search", style: { marginRight: '4px', fontSize: '16px' } }),
            react_1.default.createElement(react_select_1.components.Input, __assign({}, props))));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_select_1.default, { id: "select-list-".concat(name), isSearchable: isSearchable || false, hideSelectedOptions: hideSelectedOptions, defaultMenuIsOpen: defaultMenuIsOpen, closeMenuOnSelect: true, components: {
                IndicatorSeparator: function () { return null; },
                SingleValue: SingleValueComponent,
                Input: withSearchInputIcon ? InputComponent : react_select_1.components.Input,
                Option: withTooltipAndTruncatedText ? OptionComponent : react_select_1.components.Option,
                DropdownIndicator: defaultMenuIsOpen ? function () { return null; } : react_select_1.components.DropdownIndicator,
            }, classNamePrefix: "select", isDisabled: isDisabled, isOptionDisabled: isOptionDisabled, isClearable: isClearable, isLoading: isLoading, options: options, getOptionLabel: getOptionLabel, getOptionValue: getOptionValue, value: value, onChange: onChange, autoFocus: autoFocus, 
            // openMenuOnClick={!defaultMenuIsOpen}
            menuIsOpen: defaultMenuIsOpen, placeholder: placeholder ? (react_1.default.createElement("span", { style: {
                    fontWeight: 700,
                    color: hasError ? '#ff0000' : customFontColor || 'unset',
                } }, placeholder)) : (''), theme: function (theme) { return (__assign(__assign({}, theme), { colors: __assign(__assign({}, theme.colors), { primary: hasError ? '#ff0000' : '#5a0077', primary50: '#ecdcf9', primary25: '#f2e9f9' }) })); }, styles: {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                control: function (baseStyles, _a) {
                    var isFocused = _a.isFocused, menuIsOpen = _a.menuIsOpen;
                    return (__assign(__assign({}, baseStyles), { borderColor: hasError ? '#ff0000 !important' : customBorderFocusColor || getBorderColor(menuIsOpen), boxShadow: !customBoxShadow || hasError || !menuIsOpen ? 'none' : customBoxShadow, borderRadius: 0, borderStyle: customBorderStyle || baseStyles.borderStyle, backgroundColor: customBackgroundColor || baseStyles.backgroundColor, color: customFontColor || baseStyles.color, '&:hover': {
                            borderColor: customBorderHoverColor || baseStyles.borderColor,
                            backgroundColor: customBackgroundColorOnHover || baseStyles.backgroundColor,
                        }, cursor: 'pointer' }));
                },
                singleValue: function (provided) { return (__assign(__assign({}, provided), { color: customFontColor || provided.color })); },
                menu: function (baseStyles) {
                    return isMenuPositionStatic
                        ? {
                            position: 'static',
                        }
                        : baseStyles;
                },
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                option: function (styles, state) { return (__assign(__assign({}, styles), { cursor: 'pointer' })); },
                dropdownIndicator: function (base) { return (__assign(__assign({}, base), { color: 'black', '&:hover': {
                        color: 'black',
                    } })); },
            }, className: className })));
}
exports.default = SingleSelect;
